import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ServiceApplication_Key } from "../../config/helpers";
import { store } from "../store";

 export const apiSlice = createApi({
    reducerPath: "apiSlice",
    baseQuery: fetchBaseQuery({
      baseUrl: process.env.REACT_APP_URL_BASE_BACKEND + "/api",
      prepareHeaders: (headers, { getState }) => {
        //const token = store.getState().auth.token;
        
        //const token = store.getState().userOidc?.value?.access_token;
        const token = store.getState().auth.token;
        
        if (token) {
          headers.set("Authorisation", token);
        }
        headers.set("Access-Control-Allow-Origin", "*");
        headers.set("Application_Key", ServiceApplication_Key);
        return headers;
      },
    }),
    endpoints: (builder) => ({}),
  });


// eslint-disable-next-line no-empty-pattern
export const {} = apiSlice;

